module.exports = __webpack_public_path__ + "img/projects-empty-state.18538ca4.svg";